export default __webpack_public_path__ + "static/media/latinBug.16c9ed9d.png";